/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { excludeCampaignPostsRequestSchema } from '../campaign-schema';

export const excludeCampaignPostsPathSchema = z.object({
  campaignId: z.string(),
});

export const excludeCampaignPostsRequestBodySchema =
  excludeCampaignPostsRequestSchema;

export type ExcludeCampaignPostsInput = {
  path: z.input<typeof excludeCampaignPostsPathSchema>;
  body: z.input<typeof excludeCampaignPostsRequestBodySchema>;
  signal?: AbortSignal;
};

export async function excludeCampaignPosts({
  path,
  body,
  signal,
}: ExcludeCampaignPostsInput): Promise<void> {
  const parsedPath = excludeCampaignPostsPathSchema.parse(path);
  const parsedBody = excludeCampaignPostsRequestBodySchema.parse(body);

  await socialApiClient.post(
    `campaigns/${parsedPath.campaignId}/posts/exclude`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
}
